"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Practice = void 0;
var CreatedSkillBuildJobImpulse_1 = require("./CreatedSkillBuildJobImpulse");
var StreamingImpulse_1 = require("./StreamingImpulse");
var CanceledSkillBuildJobImpulse_1 = require("./CanceledSkillBuildJobImpulse");
/**
 * This type contains all practice sensor impulses which are used to support
 * practice in gaia.
 */
var Practice = /** @class */ (function (_super) {
    __extends(Practice, _super);
    function Practice() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "Practice";
        /**
         * Stream practice preparation impulse used to transfer a skill to gaia.
         *     This perception impulse do not invoke the data transmission but establishes
         *     a connection to the streaming api.
         */
        _this.prepare = function (impulse, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulse", impulse);
            var entity = new StreamingImpulse_1.StreamingImpulse();
            config(entity);
            return "prepare(impulse:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        _this.build = function (impulse, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulse", impulse);
            var entity = new CreatedSkillBuildJobImpulse_1.CreatedSkillBuildJobImpulse();
            config(entity);
            return "build(impulse:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        _this.cancel = function (impulse, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulse", impulse);
            var entity = new CanceledSkillBuildJobImpulse_1.CanceledSkillBuildJobImpulse();
            config(entity);
            return "cancel(impulse:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return Practice;
}(Array));
exports.Practice = Practice;
//# sourceMappingURL=Practice.js.map